import { Component, inject, input } from '@angular/core';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { SocialChannel } from 'src/app/social-media/models';
import { SocialChannelButtonsComponent } from 'src/app/social-media/components/social-channel-buttons/social-channel-buttons.component';
import { NewsletterFormComponent } from '../newsletter-form/newsletter-form.component';

@Component({
  selector: 'app-footer-socials',
  templateUrl: './footer-socials.component.html',
  standalone: true,
  styleUrls: ['./footer-socials.component.scss'],
  imports: [FromDictionaryPipe, SocialChannelButtonsComponent, NewsletterFormComponent],
})
export class FooterSocialsComponent {
  private lang = inject(LanguageService);
  private dict = new FromDictionaryPipe(this.lang);

  socials = input<SocialChannel[]>([]);
}
